import { Container } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { Card } from "@/Components/v2/atoms/Card";
import { Typography } from "@/Components/v2/atoms/Typography";

export const EmailVerification = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "background.default",
    }}
  >
    <Container maxWidth="sm">
      <Card
        sx={{
          p: 4,
          textAlign: "center",
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Box sx={{ position: "relative" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: 15,
              mb: 2.5,
              mt: 1.5,
            }}
          >
            Your email is unverified.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: 11,
              mb: 2.5,
              color: "text.secondary",
            }}
          >
            Please contact your MarSci Partner for more info.
          </Typography>
        </Box>
      </Card>
    </Container>
  </Box>
);
